import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import tvCommunicate from 'src/api/communicate/tvCommunicate';

import {
  loadJobsSuccess,
  loadJobsRequest,
  loadJobsFail,
  loadJobsByDepartmentIdSuccess,
  loadJobsByDepartmentIdRequest,
  loadJobsByDepartmentIdFail,
  reformatJobsForOptionsMenu,
  loadJobsOptionsSuccess
} from './jobActions';

import {
  loadConfigurationSuccess,
  loadConfigurationRequest,
  loadConfigurationFail
} from './configurationActions';

export const REQUEST = 'LOAD_TV_JOBS_REQUEST';
export const SUCCESS = 'LOAD_TV_JOBS_SUCCESS';
export const FAIL = 'LOAD_TV_JOBS_FAIL';

export const SET_TV_JOBS_FILTER = 'SET_TV_JOBS_FILTER';

const loadTvJobsSuccess = (jobs) => ({ type: SUCCESS, jobs });
const loadTvJobsRequest = () => ({ type: REQUEST });
const loadTvJobsFail = (error) => ({ type: FAIL, error });
export const setTvJobsFilter = (filter) => (dispatch) => dispatch({ type: SET_TV_JOBS_FILTER, filter });

export const loadConfiguration = () => (dispatch) => new Promise((resolve, reject) => {
  dispatch(loadConfigurationRequest());
  // eslint-disable-next-line no-promise-executor-return
  return tvCommunicate.request({ url: 'Configurations/Web' }).then((response) => {
    dispatch(loadConfigurationSuccess(response.data.Data));
    resolve(response);
  }).catch((e) => {
    dispatch(loadConfigurationFail(e));
    toastrError(e);
    reject(e);
  });
});

export const loadJobs = () => (dispatch) => {
  dispatch(loadJobsRequest());
  return tvCommunicate.request({ url: 'Jobs', method: 'get' }).then((response) => {
    dispatch(loadJobsSuccess(response.data.Data));
    dispatch(loadJobsOptionsSuccess(reformatJobsForOptionsMenu(response.data.Data)));
  }).catch((err) => {
    dispatch(loadJobsFail(err));
    toastrError(err);
  });
};

export const loadJobsByDepartmentId = (departmentId) => (dispatch) => {
  dispatch(loadJobsByDepartmentIdRequest());
  return tvCommunicate.request({ url: 'Jobs', method: 'get', getParams: `?departmentIds=${departmentId}` }).then((response) => {
    dispatch(loadJobsByDepartmentIdSuccess({ departmentId, list: response.data.Data }));
  }).catch((err) => {
    dispatch(loadJobsByDepartmentIdFail(err));
    toastrError(err);
  });
};

export const loadTvActivities = (params) => (dispatch) => {
  dispatch(loadTvJobsRequest());
  return tvCommunicate.request({
    url: 'CalendarEvents/CurrentActivities',
    method: 'get',
    getParams: Utils.objects.getQueryStringFromObject(params)
  }).then((response) => {
    dispatch(loadTvJobsSuccess(response.data.Data));
  }).catch((err) => {
    dispatch(loadTvJobsFail(err));
    toastrError(err);
  });
};
